import { AfterViewInit, Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, PopoverController, Events } from 'ionic-angular';
import {Http, RequestOptions, Headers} from '@angular/http';
import { EbsWebServiceGlobals } from "../../services/ebsWebServiceGlobals";
import { FilePickerPopOver } from '../../popovers/filepicker/filepicker';
import {EbsWebService} from "../../services/ebsWebService";

@Component({
  selector: 'notices',
  templateUrl: 'notices.html',
  inputs: ['noticeData']
})
export class NoticesPage implements AfterViewInit {

  noticeEnabled = false;
  noticeData: any;
  noticeDataProcessed: any = [];
  addNoticeURL: string;
  addNoticeParams: string;
  addNoticeWithFileURL: string;
  addNoticeWithFileParams: string;
  inputMessage: any;
  filepicked: boolean = false;
  base64File: any = "";
  base64FileName: any = "";
  base64FileType: any = "";
  colorDesign:string = "";

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public http: Http,
              private toastCtrl: ToastController,
              private ebsWebServiceGlobals: EbsWebServiceGlobals,
              private _ebsWebService: EbsWebService,
              public popoverCtrl: PopoverController,
              public events: Events) {
    this.events.subscribe('notices:filepicker', (base64, filename, filetype) => {
      this.base64File = base64;
      this.base64FileName = filename;
      this.base64FileType = filetype;
      this.filepicked = true;

      this.events.publish('filepickerpopover:close');
    });
  }

  ngAfterViewInit(): void {
    this.inputMessage = "";
    this.colorDesign = this.ebsWebServiceGlobals.getColorDesign();
    console.log(this.ebsWebServiceGlobals.getColorDesign());

    if (typeof this.noticeData.ListItemAction != "undefined") {
      this.getNoticeActionURLsFromWebServiceData(this.noticeData.ListItemAction);
    }

    if (typeof this.noticeData.ListItemContent != "undefined") {
      this.buildNoticeObjectsFromWebServiceData(this.noticeData.ListItemContent);
    }

  }


  getNoticeActionURLsFromWebServiceData(webServiceData) {
    if (webServiceData == null) {
      return;
    }

    webServiceData.forEach(element =>{
      switch (element.ActionName) {
        case "AddNotice":
          this.addNoticeURL = element.ActionUrl;
          this.addNoticeParams = element.PostParameters;
          break;
        case "AddNoticeWithFile":
          this.addNoticeWithFileURL = element.ActionUrl;
          this.addNoticeWithFileParams = element.PostParameters;
          break;
        default:
      }
    });
  }

  buildNoticeObjectsFromWebServiceData(webServiceData) {
    if (webServiceData == null) {
      return;
    }

    webServiceData.forEach(element =>{
      let noticeObject = {title:"",subtitle:"",date:"",icon:"",element:"",filename:"",filedata:"",filetype:"", downloadAction:"", downloadParams:"", downloadIcon:""};
      if (typeof element.ListItemContent != "undefined") {
        element.ListItemContent.forEach(childElement => {
          switch (childElement.TemplateIdentifier) {
            case "Title":
              noticeObject.title = childElement.DisplayText;
              break;
            case "Subtitle":
              noticeObject.subtitle = childElement.DisplayText;
              break;
            case "Date":
              noticeObject.date = childElement.DisplayText;
              break;
            case "Icon":
              if (childElement.ViewTypeAction == "DownloadFile" || childElement.ViewTypeAction == "Popup") {
                noticeObject.downloadAction = childElement.Action;
                noticeObject.downloadParams = childElement.PostParameters;
                noticeObject.downloadIcon = childElement.LabelCaption;
                noticeObject.element = childElement;
              } else {
                noticeObject.icon = childElement.LabelCaption;
              }
              break;
            default:
          }
        });

        if(this.base64FileName != "" && this.base64File == "") {
          noticeObject.filename = this.base64FileName;
          noticeObject.filedata = this.base64File;
          noticeObject.filetype = this.base64FileType;
        }
        console.log(noticeObject);
        this.noticeDataProcessed.push(noticeObject);
      }
    })
  }

  filePicker(myEvent) {
    let popover = this.popoverCtrl.create(FilePickerPopOver);
    popover.present({
      ev: myEvent
    });
  }

  sendButton() {
    if(this.filepicked) {
      this.addNoticeWithFile();
    } else {
      this.addNotice();
    }
  }

  addNoticeWithFile() {
    if(this.base64File != null || this.base64File != "") {
      let filetype = this.base64FileType;
          filetype = filetype.replace("image/jpeg", "jpg");
          filetype = filetype.replace("application/vnd.openxmlformats-officedocument.wordprocessingml.document", "docx");
          filetype = filetype.replace("application/pdf", "pdf");
          filetype = filetype.replace("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "xlsx");
          filetype = filetype.replace("image/png", "png");
          filetype = filetype.replace("application/vnd.ms-powerpoint", "ptt");

      let base64 = encodeURIComponent(this.base64File.split(',')[1]);

      let params = this.addNoticeWithFileParams.replace("MESSAGE", this.inputMessage);
          params = params.replace("FILEBYTES", base64);
          params = params.replace("FILETYPE", filetype)
          params = params.replace("FILENAME", this.base64FileName)
          params = params.replace("&path=", "");

      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
      this._ebsWebService.postData(this.addNoticeWithFileURL,postPayloadObject).subscribe(res=>{
        this.addObject(res);
      });

    } else {
      console.log("Keine File ausgewählt!");
    }

  }

  addNotice() {
    if(this.inputMessage != null || this.inputMessage != "") {
      let params = this.addNoticeParams.replace("MESSAGE", this.inputMessage);
      let postPayloadObject = this._ebsWebService.buildPostPayloadObjectFromGetParameters(params);
      this._ebsWebService.postData(this.addNoticeURL,postPayloadObject).subscribe(res=>{
        this.addObject(res);
      });
    } else {
      console.log("Message leer!");
    }
  }

  addObject(res) {
    let toast = this.toastCtrl.create({
      message: res.Caption,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();

    this.buildNoticeObjectsFromWebServiceData(res.ListItemContent);

    this.inputMessage = "";
    this.base64File = "";
    this.base64FileName = "";
    this.base64FileType = "";
    this.filepicked = false;
  }
}



// WEBPACK FOOTER //
// ./src/components/notices/notices.ts